import React, { PropTypes } from 'react';
import $ from 'jquery';
import cx from 'classnames';
import { fetchProduct, fetchProducts } from 'common/api/products';
import { assetAt, defaultThumbnail } from 'utils/assets';
import Modal from './Modal';

const getProductImageUrl = product => {
  if (product.image) {
    return product.image.web;
  }

  return defaultThumbnail();
};

const ProductList = ({ products }) => (
  <div className="menu">
    {products.map(p => (
      <div key={p.id} data-value={p.id} className="item">
        <img
          className="ui avatar image"
          src={getProductImageUrl(p)}
          alt="Produit"
        />
        {p.name}
      </div>
    ))}
  </div>
);

ProductList.propTypes = {
  products: PropTypes.array.isRequired,
};

export default class ProductSelector extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    product: PropTypes.string,
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      showSelector: false,
      products: [],
    };

    this.displaySelector = this.displaySelector.bind(this);
    this.hideSelector = this.hideSelector.bind(this);
    this.onSelectorReady = this.onSelectorReady.bind(this);
    this.removeProduct = this.removeProduct.bind(this);
  }

  componentDidMount() {
    $(this.refs.product).dimmer({
      on: 'hover',
    });

    // Loading product if provided
    const { product } = this.props;
    if (product) {
      this.setState({
        loading: true,
      });

      fetchProduct(product).then(selected => {
        this.setState({
          loading: false,
          selected,
        });
      });
    }
  }

  displaySelector() {
    const { id } = this.props;

    this.setState({
      loading: true,
      showSelector: false,
    });

    // Loading products
    fetchProducts().then(products => {
      const filtered = products.filter(p => p.id.toString() !== id.toString());

      this.setState({
        loading: false,
        showSelector: true,
        products: filtered,
      });
    });
  }

  hideSelector() {
    this.setState({
      loading: false,
      showSelector: false,
    });
  }

  onSelectorReady(dom) {
    $(dom)
      .find('.dropdown')
      .dropdown({
        onChange: value => this.onProductSelected(value),
      });
  }

  onProductSelected(productId) {
    const { products } = this.state;
    const selected = products.find(
      p => p.id.toString() === productId.toString()
    );
    // Allow dropdown animation to end properly
    setTimeout(() => {
      if (selected) {
        this.setState({
          loading: false,
          showSelector: false,
          selected,
        });
      }
    }, 350);
  }

  removeProduct() {
    this.setState({
      selected: undefined,
    });
  }

  getTitle() {
    const { selected } = this.state;
    if (selected) {
      return selected.name;
    }

    return this.props.title;
  }

  getProductThumbnailUrl() {
    const { selected } = this.state;
    if (selected) {
      return getProductImageUrl(selected);
    }

    return assetAt('images/product_none.png');
  }

  render() {
    const { name, title } = this.props;
    const { selected, loading, showSelector, products } = this.state;

    const selectButtonClass = cx('ui inverted small update button', {
      loading,
    });

    const productThumbnail = this.getProductThumbnailUrl();

    return (
      <div className="ui card">
        <Modal
          isOpened={showSelector}
          onOpen={this.onSelectorReady}
          onClose={this.hideSelector}
        >
          <div className="header">{title}</div>
          <div className="content">
            <div className="ui fluid selection dropdown">
              <i className="dropdown icon" />
              <div className="default text">Sélectionnez un produit</div>
              <ProductList products={products} />
            </div>
          </div>
        </Modal>
        <div className="blurring dimmable image" ref="product">
          {!!selected && (
            <input type="hidden" name={name} value={selected.id} />
          )}
          <div className="ui dimmer">
            <div className="content">
              <div className="center">
                <div className="ui vertical buttons">
                  <div
                    className={selectButtonClass}
                    onClick={this.displaySelector}
                  >
                    Sélectionner
                  </div>
                  {!!selected && (
                    <div
                      className="ui inverted small delete red button"
                      onClick={this.removeProduct}
                    >
                      Supprimer
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <img src={productThumbnail} alt="Produit" />
        </div>
        <div className="content">
          {this.getTitle()}
          {selected &&
            selected.obsolete && (
              <div
                className="ui red small horizontal label"
                style={{ marginLeft: '10px' }}
              >
                Obsolète
              </div>
            )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/ProductSelector.js